<div>
	<h1 class="h2 mb-4">{{'nav.noc_monitoring' | translate}}</h1>
	<sct-custom-table
		[columnsConfig]="columnConfig"
		[data]="tableData"
		[config]="tableConfig"
	></sct-custom-table>
</div>

